export { hexToRgb, rgbToHex } from "@material-ui/core/styles";

const toHex = (value: number) =>
	Math.round((value / 100) * 255)
		.toString(16)
		.padStart(2, "0")
		.toUpperCase();

export const applyOpacity = (hex: string, percentage: number) => `${hex}${toHex(percentage)}`;

export const opacityToHex = (opacity: number) => toHex(opacity * 100);
